module.exports = __webpack_public_path__ + "img/vegetable-artichokes-190x100.efbac34f.jpg";